export default {
  products: {
    'you_are_searching': 'Szukasz',
    'no_results': 'Brak wyników.',
    'see_all': 'Zobacz wszystkie.',
    'see_product': 'Zobacz produkt',
    'retail_price': 'Sugerowana cena detaliczna',
    'wholesale_price': 'Cena hurtowa',
    'see_wholesale_price': 'Zobacz cenę hurtową',
    'get_quote': 'Poproś o wycenę',
    'from_your_waste': 'Produkty z Twoich odpadów',
    'ready_products': 'Produkty gotowe',
    'filters_and_categories': 'Filtry i kategorie',
  },
  sidebar: {
    categories: 'Kategoria:',
    filters: 'Filtry',
    materials: 'Materiały',
    designers: 'Projektanci',
    location: 'Lokalizacja',
    price: 'Cena',
    brand: 'Marka',
    material: 'Materiały',
    more: 'więcej...',
    less: 'mniej...',
    view: 'Ilość',
    sortBy: 'Sortowanie',
    designer: 'Projektant',
    name: 'Nazwa',
    currency: 'PLN'
  },
};